import React from 'react';
import {Form, Formik} from 'formik';

import MultipleRangeSlider from 'components/multipleRangeSlider';

import GroupButton from './groupButton';

interface FilterFormProps {
  filterFields: IFilters;
  onclose: (isClose: boolean) => void;
  setFilter: (filters: IFilters) => void;
}
const FilterForm = ({filterFields, onclose, setFilter}: FilterFormProps) => {
  return (
    <Formik
      enableReinitialize
      initialValues={{
        end_price: filterFields.end_price ? filterFields.end_price : undefined,
        start_price: filterFields.start_price
          ? filterFields.start_price
          : undefined,
        type: filterFields.type ? filterFields.type : undefined,
      }}
      onSubmit={values => {
        setFilter(values);
        onclose(false);
      }}
    >
      {({values, resetForm, setFieldValue}) => (
        <Form className="flex flex-col w-full items-center gap-4 ">
          <div className=" w-full flex justify-end">
            <button
              onClick={() => {
                setFilter({});
                resetForm();
              }}
              className=" text-[14px] font-medium  text-error"
            >
              حذف همه فیلترها
            </button>
          </div>

          <div className="flex flex-col w-full py-4">
            <p className="text-[14px] font-medium text-gray-5">
              محدوده قیمت (تومان)
            </p>
            <div className="py-4 flex w-full justify-center items-center">
              <MultipleRangeSlider
                min={0}
                max={999000000}
                maxVal={values.end_price || 999000000}
                minVal={values.start_price || 0}
                setMaxVal={maxVal => setFieldValue('end_price', maxVal)}
                setMinVal={minVal => setFieldValue('start_price', minVal)}
              />
            </div>
          </div>
          <GroupButton
            onClearHandler={() => {
              onclose(false);
              resetForm();
              setFilter({});
            }}
          />
        </Form>
      )}
    </Formik>
  );
};

export default FilterForm;
